// Escapes a value for insertion into an HTML string (a v-tooltip `content`,
// which renders as HTML). Covers the five characters that can open markup or
// break out of an attribute.
const HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export const escapeHtml = (value) =>
  value == null ? '' : String(value).replace(/[&<>"']/g, (character) => HTML_ESCAPES[character]);
